import { Capacitor } from "@capacitor/core";

// Native-shell setup (CAP-3). Each call is guarded so the same code runs
// harmlessly in the browser during web development and on Firebase Hosting.

export const isNative = Capacitor.isNativePlatform();

export async function initNativeShell() {
  if (!isNative) return;

  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    // Light theme: dark status-bar icons on a light background.
    await StatusBar.setStyle({ style: Style.Light });
    if (Capacitor.getPlatform() === "android") {
      await StatusBar.setBackgroundColor({ color: "#FFFFFF" });
    }
  } catch {
    /* status-bar plugin unavailable */
  }

  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch {
    /* splash-screen plugin unavailable */
  }

  // NAT-2: inbound deep links (universal links / app links) so shared game links
  // and Firebase magic-links open inside the app.
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("appUrlOpen", ({ url }) => {
      try {
        const parsed = new URL(url);
        const path = parsed.pathname + parsed.search + parsed.hash;
        if (path && path !== window.location.pathname) {
          window.location.assign(path);
        }
      } catch {
        /* non-URL scheme */
      }
    });
  } catch {
    /* app plugin unavailable */
  }
}
